<template>
  <v-container
    fluid
    fill-height
    :style="!!enabledStepMode ? { padding: 0 } : null"
  >
    <v-layout align-center justify-center v-if="!enabledStepMode" xs12 sm6 md4 lg3>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <Header/>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 3">
          <v-card :class="($resize && $mq.above(window.mobileSize) ? 'pa-5 mb-16' : 'mb-16')" :style="'margin-bottom: 40px; --access-account-color: ' + this.accessAccountTitleStyleColor">
            <v-card-text>
              <p class="access-account ">Criar Conta</p>
              <v-text-field name="email" label="E-mail" type="text" placeholder="Digite aqui seu e-mail" v-model="form.email" @input="emailInputDebounce"  :error-messages="emailErroValidation" outlined/>
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" height="48px" @click="register" :loading="busy" :disabled="canRegister()">Cadastrar</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn block color="secondary" class="black--text" height="48px" @click="cancel()" :disabled="busy" >Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-flex :style="{ ...gradientBackgroundStyle }" v-if="enabledStepMode">
      <v-flex
        class="pa-10 pb-0"
        :style="{ ...stepsBackgroundStyle, height: '100vh', width: '100vw' }"
      >
        <p
          class="small-title-steps-mode mb-md-10"
          :style="'margin-top: 20px; --small-title-steps-color: ' + smallTitleStepStyle.color + '; --small-title-steps-size: ' + smallTitleStepStyle.fontSize"
        >
          Seja bem-vindo(a)!
        </p>

        <p
          class="big-title-steps-mode mb-md-10"
          :style="'margin-top: 5px; --big-title-steps-color: ' + bigTitleStepStyle.color + '; --big-title-steps-font-size: ' + bigTitleStepStyle.fontSize"
        >
          Qual seu e-mail?
        </p>

        <v-text-field
          class="mt-7"
          name="email"
          type="text"
          v-model="form.email"
          @input="emailInputDebounce"
          :error-messages="emailErroValidation"
          @keydown.space="(event) => event.preventDefault()"
          style="margin-bottom: 15px"
        />

        <v-layout :style="$vuetify.breakpoint.width < 351 && { marginTop: '35%' }" align-end>
          <v-row align="end">
            <v-col class="pb-0 email-resize" cols="12">
              <v-btn
                block
                color="primary"
                large
                style="margin-bottom: 10px;"
                class="login-btn-steps-mode"
                @click="register"
                :loading="busy"
                :disabled="canRegister()"
              >
                Próximo
              </v-btn>
            </v-col>
            <v-col class="pt-0" cols="12">
              <v-btn
                @click="$router.go(-1)"
                :color="accessAccountTitleStyleColor"
                large
                block
                text
              >
                Voltar
              </v-btn>
            </v-col>
          </v-row>
        </v-layout>
      </v-flex>
    </v-flex>
    <Footer v-if="!enabledStepMode"/>
  </v-container>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import { mask } from 'vue-the-mask';
import { existsEmaillLogin, existsEmaillLoginAndAppCode, sendEmailForCreateUserWithExistingAccount } from '@/common/securityserver';
import Header from "../../components/security/Header";
import Footer from "../../components/security/Footer";
import { load } from 'recaptcha-v3'
import { debounce } from "lodash";


export default {
  name: "PrimeiroAcesso",
  components: { Header, Footer },
  directives: { mask },
  data: () => ({
    recaptcha: null,
    busy: false,
    emailErroValidation: [],
    loadingEmailValidation: false,
    emailInputDebounce: null,
    form: {
      email: "",
    },
    createWithSocialAccount: false,
  }),
  watch: {
    'form.email': {
      handler: function(val) {
        this.form.email = val.toLowerCase();
        this.form.email = this.form.email.replaceAll(' ', '');
        this.isValidEmail(val)
      }
    },
  },
  computed: {
    ...mapState([
      "window", "enabledStepMode", "enabledStepMode", "accessAccountTitleStyleColor",
      "loginCardCustomStyle", "extraTitlesStyle", "bigTitleStepStyle",
      "smallTitleStepStyle", "stepsBackgroundStyle", "gradientBackgroundStyle"
    ]),
    isMobileSize() {
      return this.$resize && this.$mq.below(this.window.mobileSize);
    },
    captchaSiteKey(){
      return process.env.VUE_APP_CAPTCHA_SITE_KEY;
    },
    accessAccountTitleStyleColor(){
      return this.$store.state.accessAccountTitleStyleColor;
    },
  },
  methods: {
    ...mapMutations(['showmsg']),
    async getRecaptchaToken() {
      const token = await this.recaptcha.execute('submit');
      return token;
    },
    async debounceEmail(val) {
      if (!this.isValidEmail(val)) return
      let recaptchaToken = await this.getRecaptchaToken();
      this.validateLogin(val, recaptchaToken);
      this.busy = false;
    },
    isValidEmail(val) {
      if(!val){
        this.emailErroValidation = ['E-mail é obrigatório'];
        return false;
      }
      
      if(!(/.+@.+\..+/.test(val))){
        this.emailErroValidation = ['E-mail inválido'];
        return false;
      }
      this.busy = true;
      this.emailErroValidation = null
      return true
    },
    validateLogin(login, recaptchaToken){
      existsEmaillLoginAndAppCode(login, recaptchaToken).then(res =>{
        this.emailErroValidation = res.data ? ['E-mail não disponível'] : null
      }).catch(error => {
        if (error.response.data.message) {
          this.showmsg({
              text: error.response.data.message,
              type: "error",
            });
        }
      });

      this.emailErroValidation = null;
    },
    canRegister() {
      const formHasData = this.form.email && !this.emailErroValidation;
      return !formHasData;
    },
    async register() {
      this.busy = true;
      let recaptchaToken = await this.getRecaptchaToken();

      existsEmaillLogin(this.form.email, recaptchaToken).then(async res =>{
        if(res.data){
          let user = {
            login : this.form.email
          }

          recaptchaToken = await this.getRecaptchaToken();
          sendEmailForCreateUserWithExistingAccount(user, recaptchaToken).then(() => {
            this.showmsg({
              text: 'Para finalizar o cadastro, acesse seu e-mail e siga as instruções.',
              type: "error",
              timeout: -1,
            });
            this.$router.go(-1);
          }).catch(error => {
            this.showmsg({
              text: error && error.response && error.response.data && error.response.data.message 
                ? error.response.data.message  : 'Não foi possível completar a requisição.\nPor favor, tente novamente mais tarde.',
              type: "error",
            });
            this.busy = false;
          });
          
        }else{
          this.$store.commit('email', this.form.email);
          this.$router.push('/primeiro-acesso');
        }
      }).catch(error => {
        this.showmsg({
          text: error && error.response && error.response.data && error.response.data.message 
            ? error.response.data.message  : 'Não foi possível completar a requisição.\nPor favor, tente novamente mais tarde.',
          type: "error",
        });
        this.busy = false;
      });
    },
    cancel(){
      this.$store.commit('userServiceLogin', {});
      this.$router.go(-1);
    },
  },
  async created() {
    this.recaptcha = await load(process.env.VUE_APP_CAPTCHA_V3_SITE_KEY);
    this.emailInputDebounce = debounce(this.debounceEmail, 3000)
  },
  beforeDestroy() {
    this.emailInputDebounce = null
  }
};
</script>

<style scoped>
  /* large */
  @media (min-height: 670px) and (min-width: 411px){
    .email-resize {
      margin-top: 250px;
    }
  }

  /* medium */
  @media (min-height: 700px) and (min-width: 350px) and (max-width: 410px){
    .email-resize {
      margin-top: 250px;
    }
  }

  /* small */
  @media (max-height: 699px) and (min-width: 350px) and (max-width: 410px){
    .email-resize {
      margin-top: 150px;
    }
  }
</style>